import React from 'react';
import {Box, Divider, Stack} from '@mui/material';
import PropTypes from 'prop-types';

const categoryColours = {
    Admissions: '#0dad95',
    Boarding: '#9333ea',
    Staff: '#f59e0b',
    General: '#64748b',
    Blank: '#d0d0d0',
    Medical: '#dc2626',
    'Trips and Activities': '#2563eb',
    Clubs: '#db2777',
    Notification: '#f97316',
    'Senior School Admissions': '#0dad95',
    'SEN and Welfare': '#FFEB3B',
    'After-School Clubs': '#db2777',
    'School Template': '#2080C0',
};

const FormTemplatePreviewVisual = ({category}) => {
    const headerColour = categoryColours[category] || categoryColours.General;
    return (
        <Box
            sx={{
                width: '100%',
                height: 160,
                backgroundColor: headerColour,
                borderBottom: '1px solid #eee',
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
                alignItems: 'center',
                pt: 4,
            }}
        >
            <Box
                sx={{
                    width: '65%',
                    height: '80%',
                    backgroundColor: '#fff',
                    borderTopLeftRadius: 6,
                    borderTopRightRadius: 6,
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'stretch',
                    p: 2,
                    position: 'relative',
                }}
            >
                <Box
                    sx={{
                        height: 8,
                        borderRadius: 2,
                        backgroundColor: '#64748b',
                        mb: 1.5,
                    }}
                />

                <Stack spacing={1}>
                    <Box sx={{
                        height: 14,
                        width: '90%',
                        backgroundColor: '#e5e7eb',
                        borderRadius: 1
                    }}/>
                    <Box sx={{
                        height: 14,
                        width: '80%',
                        backgroundColor: '#e5e7eb',
                        borderRadius: 1
                    }}/>
                    <Box sx={{
                        height: 14,
                        width: '95%',
                        backgroundColor: '#e5e7eb',
                        borderRadius: 1
                    }}/>

                    <Divider sx={{my: 1}}/>

                    <Box
                        sx={{
                            height: 28,
                            width: '40%',
                            backgroundColor: '#d1d5db',
                            borderRadius: 1,
                            alignSelf: 'flex-start',
                        }}
                    />
                </Stack>
            </Box>
        </Box>
    );
};

FormTemplatePreviewVisual.propTypes = {
    bgColour: PropTypes.string,
    category: PropTypes.string,
};

export default FormTemplatePreviewVisual;
